import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import mixCommon from '@/common/mixCommon'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo, setTitle } from '@/libs/util'
import VersionCheck from '@/libs/versions'
import config from '@/config'
import mixConfig from '../common/config'
import { setLevelCookie, getLevelCookie } from '@/libs/util' // 引入处理cookie的函数，根据实际路径修改
const { homeName, cookieExpires } = config // 引入cookieExpires配置

Vue.use(Router)
const RouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
  return RouterReplace.call(this, to).catch(err => err)
}
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'

const turnTo = (to, access, next) => {
  next()
}

router.beforeEach((to, from, next) => {
  // 处理LevelA到LevelE的cookie
  const levels = []
  levels.forEach(level => {
    const defaultValue = level.toLowerCase()
    let value = getLevelCookie(level)
    if (!value) {
      // console.log('调用 setLevelCookie，参数：', level, defaultValue);
      setLevelCookie(level, defaultValue, { expires: cookieExpires || 7 }) // 设置cookie时传入expires参数
    }
  })

  // 打印当前所有的cookie
  const allCookies = document.cookie.split('; ').map(cookie => cookie.split('=')[0])
  // console.log('当前所有的cookie:', allCookies);

  // 原有的路由处理逻辑
  // let leftMenu = JSON.parse(sessionStorage.getItem('leftMenu')) || store.state.leftMenu;
  // // console.log('跳转', to)
  // // console.log('菜单数据列表', leftMenu)
  // let objm = {}
  // if (leftMenu) {
  //   leftMenu.map((item1, index1) => {
  //     if (item1.frontPath == to.name && item1.children.length <= 0) {
  //       objm = { activeMenu2: item1.id, activeMenu3: '', activeMenu4: '', activeMenuName: `${item1.name}` }
  //     } else {
  //       let offIndex1 = mixCommon.findkeyIndex(item1.children, 'frontPath', to.name)
  //       if (offIndex1 > -1) {
  //         let offIndex2 = mixCommon.findkeyIndex(item1.children[offIndex1].children, 'frontPath', to.name)
  //         if (offIndex2 > -1) {
  //           let offIndex3 = mixCommon.findkeyIndex(item1.children[offIndex1].children[offIndex2].children, 'frontPath', to.name)
  //           if (offIndex3 > -1) {
  //             objm = { activeMenu2: item1.children[offIndex1].idPath, activeMenu3: item1.children[offIndex1].children[offIndex2].idPath, activeMenu4: item1.children[offIndex1].children[offIndex2].children[offIndex3].idPath, activeMenuName: `${item1.name}/${item1.children[offIndex1].name}/${item1.children[offIndex1].children[offIndex2].name}/${item1.children[offIndex1].children[offIndex2].children[offIndex3].name}` }
  //           } else {
  //             objm = { activeMenu2: item1.children[offIndex1].idPath, activeMenu3: item1.children[offIndex1].children[offIndex2].idPath, activeMenuName: `${item1.name}/${item1.children[offIndex1].name}/${item1.children[offIndex1].children[offIndex2].name}.name}` }
  //           }
  //         } else {
  //           objm = { activeMenu2: item1.children[offIndex1].idPath, activeMenu3: '', activeMenu4: '', activeMenuName: `${item1.name}/${item1.children[offIndex1].name}` }
  //         }
  //       } else if (item1.children && item1.children.length > 0) {
  //         item1.children.map((item2, index2) => {
  //           let offIndex2 = mixCommon.findkeyIndex(item2.children, 'frontPath', to.name)
  //           if (offIndex2 > -1) {
  //             objm = { activeMenu2: item2.idPath, activeMenu3: item2.children[offIndex2].idPath, activeMenuName: `${item1.name}/${item2.name}/${item2.children[offIndex2].name}` }
  //           }
  //         })
  //       }
  //     }
  //   })
  //   // console.log('objm  存储数据', objm)
  //   store.commit('set_menuName', objm)
  // }

  // window.nowUrlName = to.name
  // let valiToken = sessionStorage.getItem('token')
  // console.log(mixCommon.findkeyIndex(mixConfig.routerList, '', to.name) <= -1)
  // if (mixCommon.findkeyIndex(mixConfig.routerList, '', to.name) <= -1 &&!valiToken) {
  //   console.log('----->跳转login')
  //   next({ name: 'login' })
  // } else {
  //   if (mixCommon.findkeyIndex(mixConfig.routerList, '', to.name) <= -1) {
  //     if (to.query) {
  //       to.query.qts = new Date().getTime()
  //     } else {
  //       to.query = { qts: new Date().getTime() }
  //     }
  //   }
  //   next()
  // }
  next()
})

router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
  // VersionCheck.checkVersion()
})

export default router
